var Schema = require("lib/shared/Schema");
var APIClient = require("lib/web/APIClient");
var ActionUtility = require("lib/shared/ActionUtility");
var Queries = require("lib/shared/Queries");

export function fetchReport({ query, cache }) {
	var params = _.extend({}, query);
	var reportKey = $wr.sortedJSON(_.omit(params, "report_lock"));
	var preSchemaF = (x) => x.results.report_key = reportKey;

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getAnalyzeClassResults,
			{ results: Schema.REPORT },
			{ params },
			{ reducer: "reports", loading: reportKey, cache, preSchemaF }));
	}
}

export function fetchQuizzes({ filters, conditions, embeds, page, cache }) {
	return (dispatch) => {
		var params = Queries.toQuery(filters, conditions);
		var pagination = { key: $wr.sortedJSON(params), page };
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getQuizzes,
			{ quizzes: [Schema.QUIZ] },
			{ params, embeds, page },
			{ reducer: "quizzes", loading: "index", cache, pagination }));

	}
}

export function fetchDigests({ filters, conditions, cache, query }) {
	return (dispatch) => {
		var params = Queries.toQuery(filters, conditions);
		params = _.extend(params, query);

		return dispatch(ActionUtility.fetchRecords(
			APIClient.getDigests,
			{ digests: [Schema.DIGEST] },
			{ params },
			{ reducer: "digests", loading: "index", cache }));
	}
}

export function fetchWidgetDigests({ filters, conditions, cache, query }) {
	return (dispatch) => {
		var params = Queries.toQuery(filters, conditions);
		params = _.extend(params, query);

		return dispatch(ActionUtility.fetchRecords(
			APIClient.getWidgetDigests,
			{ widget_digests: [Schema.WIDGET_DIGEST] },
			{ params },
			{ reducer: "widgetDigests", loading: "index", cache }));
	}
}


export function postWidgetJobTrigger(params){
	return (dispatch)=>{
		return APIClient.postWidgetDigestsTrigger(params)
	}
}

export function fetchSurveyPrompts({ filters, conditions, cache, query }) {
	return (dispatch) => {
		var params = Queries.toQuery(filters, conditions);
		params = _.extend(params, query);
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getSurveyPrompts,
			{ survey_prompts: [Schema.SURVEY_PROMPT] },
			{ params },
			{ reducer: "surveyPrompt", loading: "index", cache }));
	}
}

export function createDataExport({ data_export, embeds }) {
	var params = { data_export: data_export };

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postDataExports,
			{ data_export: Schema.DATA_EXPORT },
			{ embeds, params },
			{ reducer: "dataExports", loading: "create" }
		))
	}
}

export function clearDataLoading() {
	return (dispatch) => {
		return Promise.all([
			dispatch(ActionUtility.clearLoadingRecords("books")),
			dispatch(ActionUtility.clearLoadingRecords("quizzes")),
			dispatch(ActionUtility.clearLoadingRecords("logs")),
			dispatch(ActionUtility.clearLoadingRecords("digests")),
			dispatch(ActionUtility.clearLoadingRecords("answers")),
			dispatch(ActionUtility.clearLoadingRecords("readingLevels")),
			dispatch(ActionUtility.clearLoadingRecords("widgetDigests")),
			dispatch(ActionUtility.clearLoadingRecords("dataExports"))
		]);
	}
}


// WEBPACK FOOTER //
// ./modules/lib/actions/DataActions.js